/* global axios */
import ApiClient from './ApiClient';

class AiProviderSettingsAPI extends ApiClient {
  constructor() {
    super('ai_provider_setting', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  upsert(data) {
    return axios.put(this.url, { ai_provider_setting: data });
  }

  testConnection(data) {
    return axios.post(`${this.url}/test_connection`, {
      ai_provider_setting: data,
    });
  }

  fetchModels(data) {
    return axios.post(`${this.url}/models`, { ai_provider_setting: data });
  }
}

export default new AiProviderSettingsAPI();
